var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9998 6.00164C22.9999 4.90164 22.1 4.00157 21 4.00148L5 4.00016C3.9 4.00007 2.99993 4.9 2.99984 6L2.99885 18C2.99876 19.1 3.89869 20.0001 4.99869 20.0002L20.9987 20.0015C22.0987 20.0016 22.9988 19.1016 22.9989 18.0016L22.9998 6.00164ZM20.9998 6.00148L12.9994 11.0008L4.99984 6.00016L20.9998 6.00148ZM12.9993 13.0008L4.99967 8.00016L4.99885 18.0002L20.9989 18.0015L20.9997 8.00148L12.9993 13.0008Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail24Px);
export default __webpack_public_path__ + "static/media/email_24px.c63aedf48ef0ca15db5f1dcce5701559.svg";
export { ForwardRef as ReactComponent };